export default __webpack_public_path__ + "static/media/widget_watchbox_vpmspx5_sell.18189a1d.mp3";